(() => {
  'use strict';
  const settings = document.querySelector('[data-lnw-next-settings]');
  if (!settings) return;
  const text = JSON.parse(settings.textContent);
  let view = 'grid';
  try { view = sessionStorage.getItem('lnw-search-view') === 'list' ? 'list' : 'grid'; } catch (_) { /* Storage is optional. */ }
  let removed = null;
  // Empire reloads the cart after removing its final line. Keep only this tab's
  // undo snapshot briefly so that reload does not lose the restore action.
  try {
    const saved = JSON.parse(sessionStorage.getItem('lnw-cart-undo') || 'null');
    if (saved && Date.now() - saved.removedAt < 300000 && saved.id && saved.quantity > 0) removed = saved;
    else sessionStorage.removeItem('lnw-cart-undo');
  } catch (_) { /* Removal still works when storage is unavailable. */ }
  let restoring = false;

  function headerSearch() {
    return Array.from(document.querySelectorAll('.site-header-main input[name="q"]')).find(input => input.getClientRects().length);
  }
  function sync() {
    if (document.body.classList.contains('template-search')) {
      document.body.classList.toggle('lnw-search-header-ready', Boolean(headerSearch()));
      document.querySelectorAll('[data-lnw-search-items]').forEach(grid => grid.classList.toggle('lnw-search-list', view === 'list'));
      document.querySelectorAll('[data-lnw-search-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lnwSearchView === view)));
    }
    const subtotal = document.querySelector('.cart-subtotal [data-cart-total]');
    const sticky = document.querySelector('[data-lnw-cart-sticky-amount]');
    if (subtotal && sticky && sticky.textContent !== subtotal.textContent) sticky.textContent = subtotal.textContent;
    const undo = document.querySelector('[data-lnw-cart-undo]');
    if (undo && removed && !restoring) {
      const stillPresent = Array.from(document.querySelectorAll('[data-cartitem]')).some(line => line.dataset.cartitemKey === removed.key);
      if (!stillPresent) {
        undo.hidden = false;
        const message = undo.querySelector('[data-lnw-undo-message]');
        if (message.textContent !== text.removed) message.textContent = text.removed;
      }
    }
  }
  document.addEventListener('click', event => {
    const edit = event.target.closest('[data-lnw-edit-search]');
    if (edit) {
      const input = headerSearch();
      if (input) { input.scrollIntoView({ block:'center' }); input.focus(); input.select(); }
    }
    const toggle = event.target.closest('[data-lnw-search-view]');
    if (toggle) {
      view = toggle.dataset.lnwSearchView;
      try { sessionStorage.setItem('lnw-search-view', view); } catch (_) { /* Storage is optional. */ }
      sync();
    }
    const remove = event.target.closest('[data-cartitem-remove]');
    if (remove) {
      const line = remove.closest('[data-cartitem]');
      const data = line && line.querySelector('[data-lnw-cart-restore]');
      const quantity = line && line.querySelector('input[name="updates[]"]');
      if (data) {
        removed = { ...JSON.parse(data.textContent), key:line.dataset.cartitemKey };
        if (quantity) removed.quantity = Number(quantity.value);
        removed.removedAt = Date.now();
        try { sessionStorage.setItem('lnw-cart-undo', JSON.stringify(removed)); } catch (_) { /* Optional undo across reload. */ }
        const undo = document.querySelector('[data-lnw-cart-undo]');
        if (undo) undo.hidden = true;
      }
    }
    const undoButton = event.target.closest('[data-lnw-undo-action]');
    if (undoButton && removed && !restoring) {
      restoring = true;
      undoButton.disabled = true;
      const item = { id:removed.id, quantity:removed.quantity };
      // Liquid returns an empty array for a line without properties; the Ajax
      // API expects a property map. Omit empty properties entirely.
      const properties = Array.isArray(removed.properties) ? Object.fromEntries(removed.properties) : removed.properties;
      if (properties && Object.keys(properties).length) item.properties = properties;
      if (removed.sellingPlan) item.selling_plan = removed.sellingPlan;
      fetch(text.cartAdd + '.js', {
        method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body:JSON.stringify({ items:[item] })
      }).then(response => {
        const status = document.querySelector('[data-lnw-cart-undo]');
        if (status) status.dataset.lnwRestoreStatus = String(response.status);
        if (!response.ok) throw new Error('restore unavailable');
        try { sessionStorage.removeItem('lnw-cart-undo'); } catch (_) { /* Storage is optional. */ }
        // Reload the server-rendered cart so discounts, shipping and stock stay authoritative.
        location.reload();
      }).catch(() => {
        restoring = false;
        removed = null;
        try { sessionStorage.removeItem('lnw-cart-undo'); } catch (_) { /* Storage is optional. */ }
        undoButton.hidden = true;
        document.querySelector('[data-lnw-undo-message]').textContent = text.restoreFailed;
      });
    }
  }, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled'] });
  function keyboard() {
    const input = document.activeElement;
    const editing = input && input.matches('input:not([type=radio]):not([type=checkbox]), textarea, select');
    const reduced = window.visualViewport && window.innerHeight - window.visualViewport.height > 120;
    document.body.classList.toggle('lnw-keyboard-open', Boolean(editing && reduced));
  }
  document.addEventListener('focusin', keyboard);
  document.addEventListener('focusout', keyboard);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', keyboard);
  window.addEventListener('resize', sync);
  sync();
})();

// Surface only facts already present in the current locale's description.
(function () {
  function init() {
    var description = document.querySelector('#site-main .product-description');
    var panel = document.querySelector('[data-lnw-buy-facts]');
    if (!description || !panel) return;
    var clean = function (text) { return (text || '').replace(/\s+/g, ' ').trim(); };
    var facts = panel.querySelector('[data-lnw-fit-facts]');
    var labels = /^(mount|lens mount|compatible cameras|device compatibility|เมาท์|เมาท์เลนส์|รุ่นกล้องที่รองรับ|อุปกรณ์ที่รองรับ)$/i;
    description.querySelectorAll('table tr').forEach(function (row) {
      var cells = row.querySelectorAll('td,th');
      if (cells.length !== 2 || !labels.test(clean(cells[0].textContent)) || !clean(cells[1].textContent)) return;
      var term = document.createElement('dt'), value = document.createElement('dd');
      term.textContent = clean(cells[0].textContent);
      value.textContent = clean(cells[1].textContent);
      facts.append(term, value);
    });
    var heading = Array.from(description.querySelectorAll('h2,h3,h4')).find(function (node) {
      return /^(what.?s in the box|in the box|box contents|ในกล่อง|อุปกรณ์ในกล่อง|สิ่งที่อยู่ในกล่อง|อุปกรณ์ภายในกล่อง)$/i.test(clean(node.textContent));
    });
    var list = heading && heading.nextElementSibling;
    if (list && list.matches('ul,ol')) {
      Array.from(list.children).filter(function (item) { return item.matches('li'); }).forEach(function (item) {
        var value = clean(item.textContent);
        if (!value) return;
        var li = document.createElement('li');li.textContent = value;
        panel.querySelector('[data-lnw-box-items]').appendChild(li);
      });
    }
    var box = panel.querySelector('[data-lnw-box-facts]');
    box.hidden = !panel.querySelector('[data-lnw-box-items]').children.length;
    panel.hidden = !facts.children.length && box.hidden;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
}());
